var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whole-popover-mian"},_vm._l((_vm.arr),function(item,index){return _c('div',{key:index,staticClass:"whole-popover-li"},[(_vm.hasChildren(item))?_c('div',{staticClass:"popover-li-header"},[_vm._v("\n      "+_vm._s(item.meta && item.meta.title)+"\n    ")]):_vm._e(),(_vm.hasChildren(item))?_c('SidebarPopover',{attrs:{"basePath":item.path,"item":item,"activeId":_vm.activeId,"isWhole":true},on:{"close":_vm.closePopover}}):_c('div',{class:[
        'whole-single-menu',
        'sidebar-popover-li',
        _vm.activeMenu.indexOf('-' + item.id + '-') > -1
          ? 'popover-li-active'
          : '',
      ],on:{"click":function($event){$event.stopPropagation();return _vm.popoverClick([item.path], item.children, item)}}},[_vm._v("\n      "+_vm._s(item.meta && item.meta.title)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }